import { StyledFlexColumn } from "../../../../../../styles/LayoutStyles";
import FontForm from "../default/font/FontForm";
import PositionForm from "../default/position/PositionForm";
import SizeForm from "../default/size/SizeForm";

function VisFieldFormView({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  return (
    <StyledFlexColumn>
      {/* Position */}
      <PositionForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Size */}
      <SizeForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />

      {/* Font */}
      <FontForm
        setPrinterData={setPrinterData}
        selectedLabelItem={selectedLabelItem}
        selectedLabelItemIndex={selectedLabelItemIndex}
        submitError={submitError}
      />
    </StyledFlexColumn>
  );
}

export default VisFieldFormView;
